module.exports = __webpack_public_path__ + "static/media/audio.8141fba9.gif";